import React, { useState, useEffect } from "react";
import { Container, Col, Row, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useCheckUser from "../custom-hooks/useCheckUser";
import useViewport from "../custom-hooks/useViewport ";
import axiosInstance from "../api/axiosInstance";
import LoaderBtn from "../components/LoaderBtn";

function OldProducts() {
  const [type, setType] = useState(0);
  const [typeText, setTypeText] = useState("");
  const [typeProList, setTypeProList] = useState([]);
  const [cost, setCost] = useState("");
  const [description, setDescription] = useState("");
  const [productType, setProductType] = useState("");
  const [load, setLoad] = useState(false);
  const UserID = localStorage.getItem("UserId");
  const { width } = useViewport(); //custom hook for responsive layouts

  // Example usage of the custom hook
  useCheckUser(UserID); // Replace UserID with the actual user ID value

  useEffect(() => {
    axiosInstance.post("GetDevice").then((res) => {
      if (res.data.result === "true") {
        setTypeProList(res.data.data);
      } else {
        toast.error(res.data.message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      }
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (type === 0 || cost === "" || description === "" || productType === "") {
      toast.error("لطفا اطلاعات را تکمیل کنید ", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      return;
    }
    setLoad(true);
    axiosInstance
      .post("InsertDev", {
        Id: 0,
        Tittle: 1,
        Pid: UserID,
        Filed_Id: type,
        Filed: typeText,
        Type_Free: cost,
        Text: description,
        IsFree: productType === "1" ? true : false,
      })
      .then((res) => {
        setLoad(false);
        setType(0);
        setCost("");
        setDescription("");
        setProductType("");
        if (res.data.result === "true") {
          toast.success(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      });
  };

  const formSubmit = (event) => {
    event.preventDefault();
  };

  const handleChangeProduct = (e) => {
    setType(e.target.value);
    setTypeText(e.target.options[e.target.selectedIndex].text);
  };

  return (
    <div className="pt-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} className="rgc-title">
            <h3>کالای مستعمل</h3>
            <p>
              هم‌اکنون در کشورهای پیشرفته کاربردی‌ترین نوع نظرسنجی، نظرسنجی
              اینترنتی است ولی در کشورهایی مانند پاکستان و افغانستان که امکانات
              نظرسنجی اینترنتی به صورت همگانی میسر نیست، اغلب از شیوه‌های کلاسیک
              نظر سنجی مانند پرسش و پاسخ یا مصاحبه استفاده می‌شود. در ایران نیز
              نظرسنجی‌هایی توسط موسسات تحقیقاتی و صدا و سیما در اغلب مشارکت‌های
              عمومی صورت می‌پذیرد و نظر قشری از جامعه را منعکس می‌سازد. اخیراً
              پیشرفت‌هایی در زمینه برگزاری نظرسنجی‌های آنلاین به زبان فارسی حاصل
              شده‌است که این امکان را فراهم می‌آورد تا کاربران بتوانند فرم‌های
              نظرسنجی مورد نظرشان را به صورت برخط (آنلاین) ایجاد کنند و آن‌ها را
              بین افراد توزیع و نتایج را بصورت برخط مشاهده کنند.
            </p>
            <Form>
              <Row className="justify-content-start">
                <Col md="6" className="mb-3">
                  <Form.Group controlId="formBasicSelect">
                    <Form.Label>نوع کالا:</Form.Label>
                    <Form.Control
                      as="select"
                      browser-default
                      custom-select
                      className="rgc-drop-control"
                      value={type}
                      onChange={(e) => handleChangeProduct(e)}
                    >
                      {" "}
                      <option key={0} value="0">
                        لطفا کالای مورد نظر خود را انتخاب نمایید
                      </option>
                      {typeProList.map((data, index) => (
                        <option key={index} value={data.id}>
                          {data.Title}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md="6" className="mb-3">
                  <form className="rgc-radio" onSubmit={formSubmit}>
                    <div className="radio">
                      <label>
                        <input
                          type="radio"
                          value="1"
                          checked={productType === "1"}
                          onChange={(e) => setProductType(e.target.value)}
                        />
                        رایگان
                      </label>
                    </div>

                    <div className="radio">
                      <label>
                        <input
                          type="radio"
                          value="0"
                          checked={productType === "0"}
                          onChange={(e) => setProductType(e.target.value)}
                        />
                        نقدی
                      </label>
                    </div>
                  </form>
                </Col>

                <Col md="6" className="mb-3">
                  <Form.Group>
                    <Form.Label>مبلغ کالا:</Form.Label>
                    <Form.Control
                      className="rgc-font-number"
                      placeholder="مبلغ کالا"
                      type={width > 820 ? "text" : "number"}
                      value={cost}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onChange={(e) => setCost(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </Col>

                <Col md="12">
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>شرح:</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      className="rgc-font-number"
                      placeholder=""
                      type="text"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <br />

                <Col xs="9" md="5" className="text-center m-auto">
                  <Button
                    className="btn-fill rgc-btn m-auto"
                    type="submit"
                    variant="primary"
                    onClick={handleSubmit}
                  >
                    <LoaderBtn loads={load} />
                    <span>ثبت</span>
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default OldProducts;
